
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { PackageSubTypeSource } from '@/Sources';
  import { IPackageSubType } from '@/Interfaces';

  @Component({
    name: 'package-sub-type-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class PackageSubTypeDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop() public packageTypeId!: number;
    @Prop({ default: 'Sub Type' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    public source: PackageSubTypeSource | IPackageSubType[] = [];

    public async mounted() {
      this.source = new PackageSubTypeSource(this.packageTypeId);
    }

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
